import { render, staticRenderFns } from "./dataAuthView.vue?vue&type=template&id=55d96857"
import script from "./dataAuthView.vue?vue&type=script&lang=js"
export * from "./dataAuthView.vue?vue&type=script&lang=js"
import style0 from "./dataAuthView.vue?vue&type=style&index=0&id=55d96857&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d96857')) {
      api.createRecord('55d96857', component.options)
    } else {
      api.reload('55d96857', component.options)
    }
    module.hot.accept("./dataAuthView.vue?vue&type=template&id=55d96857", function () {
      api.rerender('55d96857', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/data_auth/dataAuthView/dataAuthView.vue"
export default component.exports